import Box from "@mui/material/Box";
import React from "react";
import { TABLE_HEADER_ARRAY } from "../utils/Types";

enum CHART_TYPE {
  BAR = "BAR",
  PIE = "PIE",
  GROUP_BAR = "GROUP_BAR",
  TABLE = "TABLE",
  SCATTER = "SCATTER",
  STACK = "STACK",
}

type BaseChartProps = {
  isLoading?: boolean;
  title: string;
  tooltipTitle: string;
  props?: any;
  renderChart: (args: RenderChartProps) => React.ReactNode;
};

type ChartContainerProps = BaseChartProps & {
  data: Array<any> | { headers: TABLE_HEADER_ARRAY; rowData: Array<any> };
  chartType?: CHART_TYPE;
};

type RenderChartProps = Omit<ChartContainerProps, "renderChart">;

const ChartContainer: React.FC<ChartContainerProps> = ({
  isLoading,
  data,
  title,
  tooltipTitle,
  props,
  renderChart,
  chartType = CHART_TYPE.BAR,
}) => (
  <Box
    height="23rem"
    borderRadius={2}
    bgcolor="custom.background.primary"
    p={3}
    sx={{
      overflow: "auto", // Add scroll when content overflows
      "&::-webkit-scrollbar": {
        width: "8px",
        height: "8px",
      },
      "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#c1c1c1",
        borderRadius: "4px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#a8a8a8",
      },
    }}
  >
    {renderChart({ isLoading, data, title, tooltipTitle, props, chartType })}
  </Box>
);

export { CHART_TYPE };
export type { RenderChartProps };
export default ChartContainer;
